import { makeBaseSvgIconProps } from './_utils/makeBaseSvgIconProps'

export const IconTorchOn = () => {
  return (
    <svg {...makeBaseSvgIconProps('0 0 13 26')}>
      <path d="M0 0V14.3H3.9V26L13 10.4H7.8L11.7 0H0Z" fill="currentColor" />
    </svg>
  )
}
